import { AxiosInstance } from 'axios';
import { Result } from 'services/Result';
import { TourAveragesData, TourAveragesVersion } from 'types/admin/tourAverages';

export class TourAveragesEditorService {
  private axiosInstance: AxiosInstance;
  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  getTourAverages = async (version: TourAveragesVersion): Promise<TourAveragesData | null> => {
    const response = await this.axiosInstance.get<Result<TourAveragesData>>(`/api/admin/TourAveragesAdmin`, {
      params: { version },
    });
    if (response.status === 204) {
      return null;
    }

    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error('There was an internal error while fetching Tour Averages.');
  };

  saveNewTourAverages = async (data: TourAveragesData): Promise<void> => {
    const response = await this.axiosInstance.post(`/api/admin/TourAveragesAdmin`, data);

    if (response.status !== 200) throw Error('There was an internal error while saving Tour Averages.');
  };

  updateTourAverages = async (data: TourAveragesData): Promise<void> => {
    const response = await this.axiosInstance.put(`/api/admin/TourAveragesAdmin`, data);
    if (response.status !== 200) throw Error('There was an internal error while updating Tour Averages.');
  };
}

export default TourAveragesEditorService;
